import { useEffect, useState } from 'react';
import * as d3 from 'd3';
import { useTranslation } from 'react-i18next';
import { ampli } from '../../ampli';
import { useCurrentUser } from '../../contexts/CurrentUser';
import { LoaderSmall } from '../LoaderSmall/LoaderSmall';
import { WidgetContentModal } from '../WidgetContentModal/WidgetContentModal';
import { Tooltip } from 'react-tooltip';
import { AddToNarrativeModal } from '../AddToNarrativeModal/AddToNarrativeModal';
import { AddToSourceGroupModal } from '../AddToSourceGroupModal/AddToSourceGroupModal';
import { formatNumberSignificant } from '../../utils/fomatNumbers';
import './AttitudeBar.scss';

const countriesData = {
  114032: {
    negotiate: {
      messages: 0,
      messages_share: 0.0,
      posts: 0,
      posts_share: 0.0,
      comments: 0,
      comments_share: 0.0,
      reactions: 0,
      reactions_share: 0.0,
    },
    attack: {
      messages: 9,
      messages_share: 9.0,
      posts: 6,
      posts_share: 6.0,
      comments: 0,
      comments_share: 0.0,
      reactions: 22,
      reactions_share: 1.0,
    },
    cooperate: {
      messages: 0,
      messages_share: 0.0,
      posts: 0,
      posts_share: 0.0,
      comments: 0,
      comments_share: 0.0,
      reactions: 0,
      reactions_share: 0.0,
    },
    counteract: {
      messages: 95,
      messages_share: 91.0,
      posts: 93,
      posts_share: 94.0,
      comments: 127,
      comments_share: 100.0,
      reactions: 1825,
      reactions_share: 99.0,
    },
  },
  114034: {
    negotiate: {
      messages: 48,
      messages_share: 70.0,
      posts: 3,
      posts_share: 50.0,
      comments: 13820,
      comments_share: 100.0,
      reactions: 27789,
      reactions_share: 100.0,
    },
    attack: {
      messages: 0,
      messages_share: 0.0,
      posts: 0,
      posts_share: 0.0,
      comments: 0,
      comments_share: 0.0,
      reactions: 0,
      reactions_share: 0.0,
    },
    cooperate: {
      messages: 21,
      messages_share: 30.0,
      posts: 3,
      posts_share: 50.0,
      comments: 12,
      comments_share: 0.0,
      reactions: 85,
      reactions_share: 0.0,
    },
    counteract: {
      messages: 0,
      messages_share: 0.0,
      posts: 0,
      posts_share: 0.0,
      comments: 0,
      comments_share: 0.0,
      reactions: 0,
      reactions_share: 0.0,
    },
  },
  114035: {
    negotiate: {
      messages: 84,
      messages_share: 12.0,
      posts: 38,
      posts_share: 11.0,
      comments: 370,
      comments_share: 14.0,
      reactions: 2180,
      reactions_share: 12.0,
    },
    attack: {
      messages: 436,
      messages_share: 62.0,
      posts: 221,
      posts_share: 66.0,
      comments: 1453,
      comments_share: 54.0,
      reactions: 9074,
      reactions_share: 52.0,
    },
    cooperate: {
      messages: 96,
      messages_share: 14.0,
      posts: 26,
      posts_share: 8.0,
      comments: 102,
      comments_share: 4.0,
      reactions: 1435,
      reactions_share: 8.0,
    },
    counteract: {
      messages: 89,
      messages_share: 13.0,
      posts: 52,
      posts_share: 15.0,
      comments: 748,
      comments_share: 28.0,
      reactions: 4827,
      reactions_share: 28.0,
    },
  },
  114038: {
    negotiate: {
      messages: 34,
      messages_share: 56.0,
      posts: 11,
      posts_share: 52.0,
      comments: 8,
      comments_share: 62.0,
      reactions: 22,
      reactions_share: 41.0,
    },
    attack: {
      messages: 0,
      messages_share: 0.0,
      posts: 0,
      posts_share: 0.0,
      comments: 0,
      comments_share: 0.0,
      reactions: 0,
      reactions_share: 0.0,
    },
    cooperate: {
      messages: 7,
      messages_share: 11.0,
      posts: 2,
      posts_share: 10.0,
      comments: 0,
      comments_share: 0.0,
      reactions: 0,
      reactions_share: 0.0,
    },
    counteract: {
      messages: 20,
      messages_share: 33.0,
      posts: 8,
      posts_share: 38.0,
      comments: 5,
      comments_share: 38.0,
      reactions: 32,
      reactions_share: 59.0,
    },
  },
  114039: {
    negotiate: {
      messages: 32,
      messages_share: 22.0,
      posts: 4,
      posts_share: 22.0,
      comments: 61,
      comments_share: 1.0,
      reactions: 547,
      reactions_share: 2.0,
    },
    attack: {
      messages: 0,
      messages_share: 0.0,
      posts: 0,
      posts_share: 0.0,
      comments: 0,
      comments_share: 0.0,
      reactions: 0,
      reactions_share: 0.0,
    },
    cooperate: {
      messages: 19,
      messages_share: 13.0,
      posts: 1,
      posts_share: 6.0,
      comments: 2402,
      comments_share: 24.0,
      reactions: 5064,
      reactions_share: 15.0,
    },
    counteract: {
      messages: 95,
      messages_share: 65.0,
      posts: 13,
      posts_share: 72.0,
      comments: 7660,
      comments_share: 76.0,
      reactions: 27983,
      reactions_share: 83.0,
    },
  },
  114040: {
    negotiate: {
      messages: 0,
      messages_share: 0.0,
      posts: 0,
      posts_share: 0.0,
      comments: 0,
      comments_share: 0.0,
      reactions: 0,
      reactions_share: 0.0,
    },
    attack: {
      messages: 39,
      messages_share: 6.0,
      posts: 25,
      posts_share: 7.0,
      comments: 156,
      comments_share: 2.0,
      reactions: 73940,
      reactions_share: 24.0,
    },
    cooperate: {
      messages: 0,
      messages_share: 0.0,
      posts: 0,
      posts_share: 0.0,
      comments: 0,
      comments_share: 0.0,
      reactions: 0,
      reactions_share: 0.0,
    },
    counteract: {
      messages: 562,
      messages_share: 94.0,
      posts: 355,
      posts_share: 93.0,
      comments: 9171,
      comments_share: 98.0,
      reactions: 233420,
      reactions_share: 76.0,
    },
  },
  114041: {
    negotiate: {
      messages: 0,
      messages_share: 0.0,
      posts: 0,
      posts_share: 0.0,
      comments: 0,
      comments_share: 0.0,
      reactions: 0,
      reactions_share: 0.0,
    },
    attack: {
      messages: 0,
      messages_share: 0.0,
      posts: 0,
      posts_share: 0.0,
      comments: 0,
      comments_share: 0.0,
      reactions: 0,
      reactions_share: 0.0,
    },
    cooperate: {
      messages: 0,
      messages_share: 0.0,
      posts: 0,
      posts_share: 0.0,
      comments: 0,
      comments_share: 0.0,
      reactions: 0,
      reactions_share: 0.0,
    },
    counteract: {
      messages: 13,
      messages_share: 100.0,
      posts: 2,
      posts_share: 100.0,
      comments: 0,
      comments_share: 0.0,
      reactions: 8,
      reactions_share: 100.0,
    },
  },
};

const otherData = {
  negotiate: {
    messages: 50,
    messages_share: 25.0,
    posts: 20,
    posts_share: 15.0,
    comments: 10,
    comments_share: 10.0,
    reactions: 5,
    reactions_share: 5.0,
  },
  attack: {
    messages: 80,
    messages_share: 40.0,
    posts: 50,
    posts_share: 37.5,
    comments: 20,
    comments_share: 20.0,
    reactions: 10,
    reactions_share: 10.0,
  },
  cooperate: {
    messages: 40,
    messages_share: 20.0,
    posts: 30,
    posts_share: 22.5,
    comments: 15,
    comments_share: 15.0,
    reactions: 8,
    reactions_share: 8.0,
  },
  counteract: {
    messages: 30,
    messages_share: 15.0,
    posts: 10,
    posts_share: 7.5,
    comments: 5,
    comments_share: 5.0,
    reactions: 2,
    reactions_share: 2.0,
  },
};

export const AttitudeBar = ({
  // data,
  tabList = ['messages', 'views', 'likes'],
  entity,
  entityType,
  sourceGroups,
  countries,
  startDate,
  endDate,
  report,
}) => {
  const { t } = useTranslation();
  const [currentUser] = useCurrentUser();
  const [attitudeTabs, setAttitudeTabs] = useState(tabList);
  const [attitudeBar, setAttitudeBar] = useState(attitudeTabs[0]);
  const [modal, setModal] = useState({ isVisible: false, attitude: null, contentType: null });
  const [addToCaseModal, setAddToCaseModal] = useState({ isOpen: false, contentTypes: null, attitude: null });
  const [addToGroupModal, setAddToGroupModal] = useState({ isOpen: false, contentTypes: null, attitude: null });

  const countriesIds = [114032, 114034, 114035, 114038, 114039, 114040, 114041];

  let data = otherData;
  if(countriesIds.includes(entity.id)) {
    data = countriesData[entity.id];
  }
  

  const attitudeTabsMap = {
    messages: 'Publications',
    views: 'Views',
    likes: 'Reactions',
    reactions: 'Reactions',
    posts: 'Posts',
    comments: 'Comments',
  };

  const contentTypesMap = {
    posts: 'POST',
    comments: 'COMMENT',
    reactions: 'REACTION',
    messages: null,
    articles: 'ARTICLE',
    ads: 'AD',
    videos: 'VIDEO',
    reposts: 'REPOST',
  };

  useEffect(() => {
    setAttitudeBar(attitudeTabs[0]);
  }, [attitudeTabs]);

  return (
    <div className="report-section">
      <h3 className="trend-chart-controlls">
        <div className="trend-chart-controlls__tabs">
          {t('Attitudes')}
          {attitudeTabs.map((tab) => (
            <button
              type="button"
              key={tab}
              className={attitudeBar === tab ? 'active' : ''}
              onClick={() => {
                ampli.track({
                  event_type: 'Change metric in attitude chart',
                  event_properties: {
                    user_id: currentUser?.id,
                    workspace_id: currentUser?.workspace_id,
                    entity_id: entity?.id,
                    entity_type: entityType,
                    metric: attitudeBar,
                  },
                });
                setAttitudeBar(tab);
              }}
            >
              <span>{t(attitudeTabsMap[tab])}</span>
            </button>
          ))}
        </div>
      </h3>

      {data ? (
        <div className="card">
          <div className="card-body">
            <div className="attitude-bar-container">
              {data?.negotiate[attitudeBar] > 0 && (
                <span
                  className={'attitude-bar-negotiate clickable'}
                  style={{
                    width: `${data?.negotiate[attitudeBar + '_share']}%`,
                  }}
                  onClick={() => {
                    setModal({
                      isVisible: true,
                      attitude: 'NEGOTIATE',
                      contentType: entityType === 'case' ? null : contentTypesMap[attitudeBar],
                    });
                  }}
                >
                  {formatNumberSignificant(data?.negotiate[attitudeBar])}
                </span>
              )}
              
              {data?.cooperate[attitudeBar] > 0 && (
                <span
                  className={'attitude-bar-cooperate clickable'}
                  style={{
                    width: `${data?.cooperate[attitudeBar + '_share']}%`,
                  }}
                  onClick={() => {
                    setModal({
                      isVisible: true,
                      attitude: 'COOPERATE',
                      contentType: entityType === 'case' ? null : contentTypesMap[attitudeBar],
                    });
                  }}
                >
                  {formatNumberSignificant(data?.cooperate[attitudeBar])}
                </span>
              )}
              {data?.counteract[attitudeBar] > 0 && (
                <span
                  className={'attitude-bar-counteract clickable'}
                  style={{
                    width: `${data?.counteract[attitudeBar + '_share']}%`,
                  }}
                  onClick={() => {
                    setModal({
                      isVisible: true,
                      attitude: 'COUNTERACT',
                      contentType: entityType === 'case' ? null : contentTypesMap[attitudeBar],
                    });
                  }}
                >
                  {formatNumberSignificant(data?.counteract[attitudeBar])}
                </span>
              )}
              {data?.attack[attitudeBar] > 0 && (
                <span
                  className={'attitude-bar-attack clickable'}
                  style={{
                    width: `${data?.attack[attitudeBar + '_share']}%`,
                  }}
                  onClick={() => {
                    setModal({
                      isVisible: true,
                      attitude: 'ATTACK',
                      contentType: entityType === 'case' ? null : contentTypesMap[attitudeBar],
                    });
                  }}
                >
                  {formatNumberSignificant(data?.attack[attitudeBar])}
                </span>
              )}
            </div>
            <div className="attitude-bar-stats">
              <div className="attitude-bar-stats-item">
                <span className="attitude-bar-stats-color negotiate"></span>
                <span className="attitude-bar-stats-data">{`${t('Negotiate')}: ${
                  data?.negotiate[attitudeBar + '_share'] === 0
                    ? '0'
                    : data?.negotiate[attitudeBar + '_share'].toFixed(2)
                }%`}</span>
              </div>
              <div className="attitude-bar-stats-item">
                <span className="attitude-bar-stats-color cooperate"></span>
                <span className="attitude-bar-stats-data">{`${t('Pivot')}: ${
                  data?.cooperate[attitudeBar + '_share'] === 0
                    ? '0'
                    : data?.cooperate[attitudeBar + '_share'].toFixed(2)
                }%`}</span>
              </div>
              <div className="attitude-bar-stats-item">
                <span className="attitude-bar-stats-color counteract"></span>
                <span className="attitude-bar-stats-data">{`${t('Counteract')}: ${
                  data?.counteract[attitudeBar + '_share'] === 0
                    ? '0'
                    : data?.counteract[attitudeBar + '_share'].toFixed(2)
                }%`}</span>
              </div>
              <div className="attitude-bar-stats-item">
                <span className="attitude-bar-stats-color attack"></span>
                <span className="attitude-bar-stats-data">{`${t('Attack')}: ${
                  data?.attack[attitudeBar + '_share'] === 0
                    ? '0'
                    : data?.attack[attitudeBar + '_share'].toFixed(2)
                }%`}</span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="widgetLoader">
          <LoaderSmall />
        </div>
      )}
      {modal.isVisible && (
        <WidgetContentModal
          infoModal={modal.isVisible}
          tabIndex={1}
          isChart={true}
          platformOption={null}
          type={null}
          subType={null}
          stateAffiliatedId={null}
          countryId={countries?.length > 0 ? countries : null}
          audienceRange={null}
          narrative={report ? report : entity}
          sourceGroup={
            sourceGroups?.length > 0
              ? sourceGroups?.map((sourceGroup) => sourceGroup?.value)
              : null
          }
          source={null}
          sentimentOptions={[modal.attitude]}
          eventIdsOptions={[entity.id]}
          startDate={startDate}
          endDate={endDate}
          contentTypeOptions={modal.contentType ? [modal.contentType] : null}
          onChange={(bool) => {
            setModal({ isVisible: bool, country: null });
          }}
          showAddToActions={true}
          onAddToCase={(bool) => {
            setAddToCaseModal({
              isOpen: bool,
              contentTypes: modal.contentType ? [modal.contentType] : null,
              attitude: [modal.attitude],
            });
          }}
          onAddToGroup={(bool) => {
            setAddToGroupModal({
              isOpen: bool,
              contentTypes: modal.contentType ? [modal.contentType] : null,
              attitude: [modal.attitude],
            });
          }}
        />
      )}
      {addToCaseModal.isOpen && (
        <AddToNarrativeModal
          isOpen={addToCaseModal.isOpen}
          deduplication={false}
          caseId={entityType === 'case' ? entity?.id : report?.id}
          eventIds={entityType === 'case' ? null : [entity?.id]}
          areAllMessagesSelected={true}
          contentTypes={addToCaseModal.contentTypes}
          sentiment={addToCaseModal.attitude}
          startDate={startDate}
          endDate={endDate}
          sourceGroups={sourceGroups}
          countries={countries}
          onChange={(bool) => {
            setAddToCaseModal({
              isOpen: bool,
              contentTypes: null,
              attitude: null,
            });
          }}
        />
      )}
      {addToGroupModal.isOpen && (
        <AddToSourceGroupModal
          isOpen={addToGroupModal.isOpen}
          deduplication={false}
          areAllMessagesSelected={true}
          contentTypes={addToGroupModal.contentTypes}
          sentiment={addToGroupModal.attitude}
          startDate={startDate}
          endDate={endDate}
          sourceGroups={sourceGroups}
          countries={countries}
          narrative={entityType === 'case' ? entity : report}
          eventIds={entityType === 'case' ? null : [entity?.id]}
          onChange={(bool) => {
            setAddToGroupModal({
              isOpen: bool,
              contentTypes: null,
              attitude: null,
            });
          }}
        />
      )}
    </div>
  );
};
